<template>
	<nav
		class="app-header navbar is-fixed-top"
		:class="headerClass"
		role="navigation"
		aria-label="main navigation"
	>
		<div class="navbar-brand">
			<app-logo class="navbar-item" width="180" height="40" />
		</div>

		<div class="navbar-menu">
			<div class="navbar-start">
				<router-link :to="homelink" class="navbar-item router-link">
					Home
				</router-link>
				<router-link
					v-if="dashboardlink"
					:to="dashboardlink"
					class="navbar-item router-link"
				>
					Dashboards
				</router-link>
				<router-link
					v-if="chartslink"
					:to="chartslink"
					class="navbar-item router-link"
				>
					Charts
				</router-link>
			</div>

			<div class="navbar-end">
				<router-link
					:to="settingslink"
					class="navbar-item gtm-view-settings"
				>
					<dc-icon icon="cog" size="lg" fixed-width />
				</router-link>
				<div
					v-click-outside="onClickOutside"
					class="navbar-item has-dropdown"
					:class="{ 'is-active': active }"
					@click.prevent="toggle"
				>
					<a v-if="currentUser !== null" class="navbar-link">
						<avatar
							:image="currentUser.image"
							:alt="fullName"
							:cropped="true"
							size="is-32x32"
							is-rounded
							class="header-avatar"
						/>
						{{ fullName }}
					</a>
					<div class="navbar-dropdown">
						<span @click="close">
							<router-link
								:to="profilelink"
								class="navbar-item gtm-view-logged-in-user-profile"
							>
								<dc-icon
									class="route-icon"
									icon="user"
									fixed-width
								/>Profile
							</router-link>
						</span>
						<hr class="navbar-divider" />
						<a class="navbar-item gtm-log-out" @click="logout">
							<dc-icon
								class="route-icon"
								icon="sign-out-alt"
								fixed-width
							/>
							Logout
						</a>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
import vClickOutside from "v-click-outside";
import Avatar from "@shared/components/AppAvatar";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "LayoutHeaderBar",
	components: { Avatar },
	directives: {
		clickOutside: vClickOutside.directive
	},
	data() {
		return {
			showNav: false,
			active: false
		};
	},
	computed: {
		...mapGetters({
			dashboards: "userModule/dashboards",
			charts: "chartsModule/get"
		}),
		fullName() {
			return this.currentUser.firstname + " " + this.currentUser.lastname;
		},
		headerClass() {
			return `is-${process.env.VUE_APP_RELEASE_STAGE.toLowerCase()}`;
		},
		homelink() {
			return { name: "HomePage" };
		},
		dashboardlink() {
			let link = null;
			if (this.dashboards.length) {
				link = {
					name: "dashboards.view",
					params: { id: this.dashboards[0].id }
				};
			}
			return link;
		},
		chartslink() {
			return this.charts && this.charts.length
				? { name: "charts.index" }
				: null;
		},
		profilelink() {
			return { name: "profile.index" };
		},
		settingslink() {
			return { name: "settings.index" };
		}
	},
	methods: {
		...mapActions({
			logout: "userModule/logout"
		}),
		close() {
			this.showNav = false;
		},
		toggle() {
			this.active = !this.active;
		},
		onClickOutside() {
			this.active = false;
		}
	}
};
</script>

<style lang="scss">
// @import "~@connect/scss/settings";

.navbar.app-header {
	box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
	background-color: white;
	// min-height: 5rem;
	// &.is-local {
	// 	background-color: lighten($colour-yellow, 10%);
	// }
	// &.is-development {
	// 	background-color: lighten($colour-navy, 50%);
	// }
	// &.is-staging {
	// 	background-color: $colour-light-grey;
	// }
	.navbar-brand .logo {
		max-height: 2.5em;
		margin-bottom: 0;
	}

	.header-avatar {
		margin-right: 10px;
	}
}
</style>
